<create-group [categories]="images" [allowSort]="true"></create-group>
